import { apiPHP } from '../../../services/api';


export interface iState {
  GameTemplate: iGameTemplate,
  GameState: iGameState,
}
export interface iGameTemplate {
    matrix: iSquare[][],
    chaves: {
      horizontal: iClueVetor,
      vertical: iClueVetor,
    },
}

export interface iSquare {
  numero: number,
  letra: string,
  palavra_horizontal: number,
  palavra_vertical: number,
  palavra_1?: any,
  palavra_2?: any,
  visivel?: boolean,
  destaque?: boolean,
  casa_morta?: boolean
}
// export interface iPalavraDirect {
//   id: number,
//   direcao: '0' | '1',
//   x: number,
//   y: number,
//   texto: string,
//   passatempos_id: number,
//   indice: number
// }
export interface iSquareSaved {
  numero: number,
  letra: string,
  palavraHorizontal: number,
  palavraVertical: number,
}
export interface iHouseState {
  isSubFocused: boolean,
  isCorrect: 'sim' | 'nao' | '',
  isFocused: boolean,
  isHighlight: boolean | undefined,
  scored: boolean,
  palavraHorizontal: number,
  palavraVertical: number,
}
export interface iGameSaved {
  id: number,
  passatempos_id: number,
  users_id: number,
  cache: {
    tempo: number,
    pontuacao: number,
    matrix:iSquareSaved[][]
  }
}

export interface iClue {
    id: number,
    chave: string,
    palavras_id: number,
    tamanho: number,
    indice: number,
    palavras: {
      id: number,
      direcao: number,
      x: number,
      y: number,
      fim: number
    }
}

export interface iClueVetor {
  [key: string]: iClue[],
}
export interface ScrollRef {
  scrollTo({ x, y, animated }: {x: number, y: number, animated: boolean}): void;
}
//This interface is used to manage the game logic
export interface iGameState {
  currentClueNumber: string,
  currentClueText: string,
  orientation: "horizontal" | "vertical",
  cluesInfos: iCluesInfos,
  maxScore: number,
  finished: boolean,
  completed: boolean,
  score: number,
  time: number,
  scrollElementRef?: ScrollRef,
  focusedHouse: { column: number, row: number }
  savedGame: iGameSaved,
  houseStates: iHouseState[][],
  rowsCoords: number[],
  keyboardUP: boolean,
}

export interface iCluesInfos {
  firstClueNumberHorizontal: number,
  lastClueNumberHorizontal: number,
  firstClueNumberVertical: number,
  lastClueNumberVertical: number,
}

export interface iGameDetails {
  id: number,
  texto: string,
  ordenacao: number,
  largura: number,
  altura: number,
  edicoes_id: number,
  temas_passatempos_id: number,
  created_at: Date,
  updated_at: Date,
  titulo: string,
  mini: number,
  do_dia: string,
  exibir_numero: boolean,
  contem_erros: boolean,
  tipos_de_passatempos_id: number,
  estilos_de_passatempos_id: number,
  dificuldades_id: number,
  subtitulo: string,
  curtidas_count: number,
  comentarios_count: number,
  rankings_count: number,
  data_tratada: string,
  torneio_ativo: boolean,
  tipos_de_passatempos: {
    id: number,
    tipo: string,
    ordem: number,
    nome_fantasia: string
  },
  estilos_de_passatempos: {
    id: number,
    estilo: string
  },
  dificuldades: {
    id: number,
    nome: string,
    created_at: Date,
    updated_at: Date
  },
  edicoes: {
    id: number,
    foto: string,
    ordenacao: number,
    created_at: Date,
    updated_at: Date,
    data_publicacao: Date,
    nome: string,
    valor_a_vista: number,
    a_venda: number,
    torneio_inicio: string,
    torneio_fim: string,
    dificuldades_id: number,
    subtitulo: string,
    descricao: string,
    torneio_ativo: boolean,
    dificuldades: {
      id: number,
      nome: string,
      created_at: Date,
      updated_at: Date
    }
  }
}

export const getGameDetails = async(gameID: number): Promise<iGameDetails[]>  => {
  const response = await apiPHP.get(`/passatempos/${gameID}`).catch((err) => {
      throw err;
  });
  return response.data;
};

export const getGameTemplate = async(gameID: number): Promise<iGameTemplate>  => {
  const response = await apiPHP.get(`/passatempos/${gameID}/gabarito`).catch((err) => {
    console.log("Não foi possível carregar o gabarito do jogo");
      throw err;
  });
  return response.data;
};
export const getGameSaved = async(gameID: number): Promise<iGameSaved>  => {
  const response = await apiPHP.get(`/passatempos/${gameID}/progresso`).catch((err) => {
      console.log("Não foi possível carregar o jogo salvo");
      throw err;
  });
  return response.data;
};
